import type {
	UsageLogPageDto,
	UsageLogQuery,
	UsageLogSummaryDto,
} from "@/types/ai-assistant-usage-log";
import { request } from "./ai-assistant.api";

/** Fetcher log penggunaan penyedia AI (admin, baca saja). */

function queryString(q: UsageLogQuery): string {
	const params = new URLSearchParams();
	if (q.vendor) params.set("vendor", q.vendor);
	if (q.status) params.set("status", q.status);
	if (q.days !== undefined) params.set("days", String(q.days));
	if (q.limit !== undefined) params.set("limit", String(q.limit));
	if (q.cursor) params.set("cursor", q.cursor);
	const qs = params.toString();
	return qs ? `?${qs}` : "";
}

/** Satu halaman log; `cursor` kosong = halaman pertama. */
export function fetchUsageLog(
	q: UsageLogQuery,
	signal?: AbortSignal,
): Promise<UsageLogPageDto> {
	return request<UsageLogPageDto>(
		`/usage-log${queryString(q)}`,
		{ signal },
		"Memuat log penggunaan",
	);
}

/** Ringkasan Claude vs ChatGPT untuk rentang yang sama. */
export function fetchUsageLogSummary(
	days: number,
	signal?: AbortSignal,
): Promise<UsageLogSummaryDto> {
	return request<UsageLogSummaryDto>(
		`/usage-log/summary?days=${days}`,
		{ signal },
		"Memuat ringkasan penyedia",
	);
}
